let debounce = require('lodash/debounce');

export default function showMoreInit(coreHandler){
  const targetClassName = ".js__show-more";
  class cardShowMore{
    static instanceList = [];

    constructor(element){
      this.instanceType = "cardShowMore";
      this.body = element;
      this.topPosition = null;
      this.Btn = this.body.querySelector(".js__show-more-btn") || null;
      if( this.Btn !== null ){
        this.Btn.addEventListener("click", this.toggleShow );
      } 
      this.positionCalculate = () => {
        const space = 30;
        let header = document.querySelector(".l-header__fix") || null;
        if(header){
          this.topPosition = this.body.getBoundingClientRect().top + window.pageYOffset - header.clientHeight - space;
        }else{
          this.topPosition = this.body.getBoundingClientRect().top + window.pageYOffset - space;
        }
      };
      window.addEventListener("load", this.positionCalculate );
      window.addEventListener("resize", debounce( this.positionCalculate , 300 ));
      
    }

    static init = () => {
      cardShowMore.instanceList = [...document.querySelectorAll(targetClassName)].map(v => {
        let instance = new cardShowMore(v);
        instance.positionCalculate();
        return instance;
      });
    }
    static recalculate = () => {
      cardShowMore.instanceList.forEach(v => {
        v.positionCalculate()
      });
    }

    scrollEvent = () => {
      window.scrollTo({
        top: this.topPosition,
        behavior: 'smooth'
      });
    };

    bodyShow = () => {
      return new Promise( resolve => {
        [this.body, this.Btn].forEach(v => {
          v.classList.remove("is-hidden");
          v.classList.add("is-show");
        });
        this.Btn.innerHTML = "<span><span class=\"visible_if_ja\">隠す</span><span class=\"visible_if_en\">Hidden</span><span class=\"visible_if_cn\">隐藏</span><span class=\"material-icons-outlined p-material-icon\">expand_less</span></span>";  
      });
    }
    bodyHidden = () => {
      return new Promise( resolve => {    
        [this.body, this.Btn].forEach(v =>{        
          v.classList.add("is-hidden");
          v.classList.remove("is-show");
          this.Btn.innerHTML = "<span><span class=\"visible_if_ja\">さらに表示</span><span class=\"visible_if_en\">Show More</span><span class=\"visible_if_cn\">显示更多</span><span class=\"material-icons-outlined p-material-icon\">expand_more</span></span>";
        });
        resolve();
      }).then(() =>{
        this.positionCalculate();
        this.scrollEvent();      
      });

    }
    toggleShow = () => {
      if(this.body.classList.contains("is-hidden")){
        this.bodyShow();
      }else{
        this.bodyHidden();
      }
      setTimeout( coreHandler.followBannerReflesh , 500);

    };
  }

  cardShowMore.init();
  return cardShowMore;
}